// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardFilterContainer {
  background: #fff8e8;
  border: 1px solid #efc45a;
  border-radius: 14px;
  padding: 22px 28px;
  margin-bottom: 24px;
}

.dashboardFilterRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px 40px;
}

.dashboardFilterItem {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dashboardFilterItem label {
  min-width: 160px;
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  white-space: nowrap;
}

.dashboardFilterItem select,
.dashboardFilterItem input {
  width: 260px;
  height: 42px;
  border-radius: 10px;
  border: 1px solid #ddd;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.dashboardSearch {
  margin-left: auto;
}
.dashboardFilterItem .form-control {
  flex: 1 1;
  height: 42px;
}

/* KPI cards */

.dashboardSummary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin: 25px 0;
}

.dashboardCard {
  height: 120px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 18px;
  cursor: pointer;
  border: none;
  overflow: hidden;
  transition: 0.25s;
}

.dashboardCard:hover {
  transform: translateY(-4px);
}

.workCostCard {
  background: linear-gradient(135deg, #d8d2ff, #f2efff);
  box-shadow: 0 10px 25px rgba(171, 160, 255, 0.45);
}
.workOrderCard {
  background: linear-gradient(135deg, #d8edff, #eff8ff);
  box-shadow: 0 10px 25px rgba(125, 191, 255, 0.45);
}
.billCard {
  background: linear-gradient(135deg, #e8fcfb, #ffffff);
  box-shadow: 0 10px 25px rgba(148, 231, 221, 0.45);
}
.deductionCard {
  background: linear-gradient(135deg, #fff2e8, #ffffff);
  box-shadow: 0 10px 25px rgba(255, 198, 150, 0.45);
}
.dashboardCard > div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dashboardCard img {
  object-fit: contain;
}

.dashboardCard img:first-child {
  width: 55px;
  height: 55px;
}
.dashboardCard h6 {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #444;
}
.dashboardCard h5 {
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 22px;
  font-weight: 700;
  color: #222;
}
.arrow-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
}

.arrow-icon img {
  width: 42px !important;
  height: 42px !important;
  border-radius: 50%;
  background: #f5e6df;
  padding: 8px;
}
@media (max-width: 1200px) {
  .dashboardSummary {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .dashboardSummary {
    grid-template-columns: 1fr;
  }
}
.cardContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.cardIcon {
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cardIcon img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.cardDetails {
  flex: 1 1;
  padding: 0 15px;
}

.cardDetails h6 {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  color: #444;
}

.cardDetails h5 {
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 650;
  color: #222;
}

.dashboardChartSection {
  display: flex;
  gap: 24px;
  margin-top: 25px;
  align-items: flex-start;
}

.dashboardLeft {
  width: 65%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.dashboardRight {
  width: 35%;
}

.chartCard,
.headTableCard,
.pieChartCard {
  background: #fff;
  border-radius: 24px;
  padding: 25px;

  box-shadow: 0 10px 30px rgba(34, 87, 122, 0.08);

  border: 1px solid #edf0f6;
}

.chartHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chartHeader h3,
.headTableCard h3,
.pieChartCard h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.yearFilter {
  display: flex;
  align-items: center;
  gap: 10px;
}

.yearFilter select {
  height: 42px;
  border: none;
  border-radius: 10px;
  padding: 0 14px;
  background: #fff;

  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
}

.chartLoader {
  height: 400px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 45px;
  height: 45px;

  border: 5px solid #ddd;
  border-top: 5px solid #4b7bec;
  border-radius: 50%;

  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.headTableCard table {
  margin-top: 18px;
}

.headTableCard thead {
  background: #2c78db;
  color: #fff;
}

.headTableCard th {
  padding: 14px;
}

.headTableCard td {
  padding: 12px;
}

.pieChartCard {
  text-align: center;
}

@media (max-width: 1200px) {
  .dashboardChartSection {
    flex-direction: column;
  }

  .dashboardLeft,
  .dashboardRight {
    width: 100%;
  }
}

.dashboardSummary.twoCards {
  grid-template-columns: repeat(2, 1fr);
}
`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/ProjectDashboard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,YAAY;AACd;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;AACA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;AACA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;AACA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;;EAEb,+CAA+C;;EAE/C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;;EAEhB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;;EAEb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;;EAElB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".dashboardFilterContainer {\r\n  background: #fff8e8;\r\n  border: 1px solid #efc45a;\r\n  border-radius: 14px;\r\n  padding: 22px 28px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.dashboardFilterRow {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 24px 40px;\r\n}\r\n\r\n.dashboardFilterItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.dashboardFilterItem label {\r\n  min-width: 160px;\r\n  margin: 0;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.dashboardFilterItem select,\r\n.dashboardFilterItem input {\r\n  width: 260px;\r\n  height: 42px;\r\n  border-radius: 10px;\r\n  border: 1px solid #ddd;\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.dashboardSearch {\r\n  margin-left: auto;\r\n}\r\n.dashboardFilterItem .form-control {\r\n  flex: 1;\r\n  height: 42px;\r\n}\r\n\r\n/* KPI cards */\r\n\r\n.dashboardSummary {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 20px;\r\n  margin: 25px 0;\r\n}\r\n\r\n.dashboardCard {\r\n  height: 120px;\r\n  border-radius: 18px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 12px 18px;\r\n  cursor: pointer;\r\n  border: none;\r\n  overflow: hidden;\r\n  transition: 0.25s;\r\n}\r\n\r\n.dashboardCard:hover {\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.workCostCard {\r\n  background: linear-gradient(135deg, #d8d2ff, #f2efff);\r\n  box-shadow: 0 10px 25px rgba(171, 160, 255, 0.45);\r\n}\r\n.workOrderCard {\r\n  background: linear-gradient(135deg, #d8edff, #eff8ff);\r\n  box-shadow: 0 10px 25px rgba(125, 191, 255, 0.45);\r\n}\r\n.billCard {\r\n  background: linear-gradient(135deg, #e8fcfb, #ffffff);\r\n  box-shadow: 0 10px 25px rgba(148, 231, 221, 0.45);\r\n}\r\n.deductionCard {\r\n  background: linear-gradient(135deg, #fff2e8, #ffffff);\r\n  box-shadow: 0 10px 25px rgba(255, 198, 150, 0.45);\r\n}\r\n.dashboardCard > div {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.dashboardCard img {\r\n  object-fit: contain;\r\n}\r\n\r\n.dashboardCard img:first-child {\r\n  width: 55px;\r\n  height: 55px;\r\n}\r\n.dashboardCard h6 {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #444;\r\n}\r\n.dashboardCard h5 {\r\n  margin-top: 8px;\r\n  margin-bottom: 0;\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  color: #222;\r\n}\r\n.arrow-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: 12px;\r\n}\r\n\r\n.arrow-icon img {\r\n  width: 42px !important;\r\n  height: 42px !important;\r\n  border-radius: 50%;\r\n  background: #f5e6df;\r\n  padding: 8px;\r\n}\r\n@media (max-width: 1200px) {\r\n  .dashboardSummary {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .dashboardSummary {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n.cardContent {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.cardIcon {\r\n  width: 60px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.cardIcon img {\r\n  width: 50px;\r\n  height: 50px;\r\n  object-fit: contain;\r\n}\r\n\r\n.cardDetails {\r\n  flex: 1;\r\n  padding: 0 15px;\r\n}\r\n\r\n.cardDetails h6 {\r\n  margin: 0;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  color: #444;\r\n}\r\n\r\n.cardDetails h5 {\r\n  margin: 8px 0 0;\r\n  font-size: 13px;\r\n  font-weight: 650;\r\n  color: #222;\r\n}\r\n\r\n.dashboardChartSection {\r\n  display: flex;\r\n  gap: 24px;\r\n  margin-top: 25px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.dashboardLeft {\r\n  width: 65%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.dashboardRight {\r\n  width: 35%;\r\n}\r\n\r\n.chartCard,\r\n.headTableCard,\r\n.pieChartCard {\r\n  background: #fff;\r\n  border-radius: 24px;\r\n  padding: 25px;\r\n\r\n  box-shadow: 0 10px 30px rgba(34, 87, 122, 0.08);\r\n\r\n  border: 1px solid #edf0f6;\r\n}\r\n\r\n.chartHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.chartHeader h3,\r\n.headTableCard h3,\r\n.pieChartCard h3 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n}\r\n\r\n.yearFilter {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.yearFilter select {\r\n  height: 42px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  padding: 0 14px;\r\n  background: #fff;\r\n\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.chartLoader {\r\n  height: 400px;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.spinner {\r\n  width: 45px;\r\n  height: 45px;\r\n\r\n  border: 5px solid #ddd;\r\n  border-top: 5px solid #4b7bec;\r\n  border-radius: 50%;\r\n\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.headTableCard table {\r\n  margin-top: 18px;\r\n}\r\n\r\n.headTableCard thead {\r\n  background: #2c78db;\r\n  color: #fff;\r\n}\r\n\r\n.headTableCard th {\r\n  padding: 14px;\r\n}\r\n\r\n.headTableCard td {\r\n  padding: 12px;\r\n}\r\n\r\n.pieChartCard {\r\n  text-align: center;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .dashboardChartSection {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .dashboardLeft,\r\n  .dashboardRight {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.dashboardSummary.twoCards {\r\n  grid-template-columns: repeat(2, 1fr);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
